import type { FunctionComponent } from 'react'
import React from 'react'

import type { BadgeTheme } from '../Badge'
import { Badge } from '../Badge'
import { SecurityIcon } from '../Icons/Miscellaneous/Security'
import { WarningIcon } from '../Icons/Miscellaneous/Warning'

export const AlertBadge: FunctionComponent<AlertBadgeProps> = ({
  className,
  type,
}) => {
  if (!type) {
    return null
  }

  const badgeProps = badgePropsMapper[type]

  return <Badge className={className} {...badgeProps} />
}

///////// IMPLEMENTATION /////////

export type AlertBadgeProps = {
  className?: string
  type?: AlertTypes | null
}

export enum AlertTypes {
  safety = 'safety-alert',
  brand = 'brand-alert',
  security = 'security-notice-alert',
}

const badgePropsMapper = {
  [AlertTypes.safety]: {
    icon: WarningIcon,
    theme: 'safety alert' as BadgeTheme,
    'data-testid': 'product-card-safety-alert',
  },
  [AlertTypes.security]: {
    icon: WarningIcon,
    theme: 'security notice' as BadgeTheme,
    'data-testid': 'product-card-security-notice-alert',
  },
  [AlertTypes.brand]: {
    icon: SecurityIcon,
    theme: 'brand alert' as BadgeTheme,
    'data-testid': 'product-card-brand-safety-alert',
  },
}
